module.exports = __webpack_public_path__ + "static/media/road-B.b66f8ae4.svg";